import { createManageUsersTabModel } from '../../../../components/AdminUsersPage/ManageUsersTab/createManageUsersTabModel.ts';
import { $$user } from '../../../../services/UserService/UserService';

export const $$resellerManageUsersTab = createManageUsersTabModel({
  getUsersFx: $$user.getUsersFx
});